/////////////////////////////////////////////////
//
// Manages the templates in App
//
// Please use only Vanilla JS
//
// Templates can be render in DOM or be loaded after from
// file system
//
////////////////////////////////////////////////////////////
(() => {
    class Template {

        constructor() {

            /* Configuration */
            this.idprefix   = 'template-';
            this.cache      = true;

            /* Items */
            this.items      = {};
            this.Storage    = new App.Interface.Storage('templates');

            /* Prepare */
            this.getTemplatesFromStorage();
            App.load(() => this.searchInDomForHtmlTemplates());
        }

        get url() {
            let url = '/interface/template/';
            if (App.language) url = App.language + url;
            return url;
        }

        async searchInDomForHtmlTemplates() {
            let templates = document.getElementsByTagName('template');
            for (var i = 0; i < templates.length; i++) {
                if (templates[i].getAttribute('id')) this.addTemplateFromNode(templates[i]);
            }
        }

        addTemplateFromNode(template) {
            if (template.getAttribute('id')) {
                this.extractSubTemplates(template.innerHTML);
                let id = template.getAttribute('id').replace(this.idprefix, '');
                let placeholders = template.dataset.placeholders ? template.dataset.placeholders.split(',') : [];
                this.addTemplate(id, template.innerHTML, {}, placeholders);
            }
        }

        addTemplateFromString(template) {
            let temp = document.createElement('DIV');
            temp.innerHTML = template;
            this.addTemplateFromNode(temp.firstChild);
        }

        extractSubTemplates(html) {
            let subtemplates = html.match(/<template(.*?)<\/template>/ig);
            if (subtemplates) {
                subtemplates.forEach(subtemplate => this.addTemplateFromString(subtemplate));
            }
        }

        getTemplatesFromStorage() {
            let storage = this.Storage.get();
            if (storage && this.cache) {
                this.items = storage;
            }
        }

        addTemplate(identifier, html, params = {}, placeholders) {
            if (html !== null && this.items[identifier] === undefined) {
                this.items[identifier] = {
                    html:           html,
                    params:         params,
                    placeholders:   placeholders,
                };
                this.Storage.set(this.items);
            }
        }

        /**
         * @warning: sync return a promise, async an object
         * @param identifier
         * @param async
         * @returns {Promise<unknown>|*}
         */
        getTemplate(identifier, async = false) {
            if (async) {
                return new Promise(r => r(this.items[identifier] || this.fetch(identifier, async)));
            } else {
                return this.items[identifier] || this.fetch(identifier, async);
            }
        }

        /**
         * @warning: sync return a promise, async an object
         * @param identifier
         * @param async
         */
        fetch(identifier, async) {
            let template;
            const promise = new Promise(resolve => {
                // @todo: replace with native `fetch`
                $.ajax({
                    url:        this.url + identifier,
                    async:      async,
                    dataType:   'json',
                }).done(json => {
                    template = this.done(json, identifier);
                    resolve(template);
                }).fail(() => {
                    this.error(identifier);
                });
            });
            return async ? promise : template;
        }

        done(json, identifier) {
            for (let key in json) {
                let template = json[key];
                if (template.storage) {
                    this.extractSubTemplates(template.html);
                    this.addTemplate(key, template.html, template.params, template.placeholders);
                }
            }
            return this.adapt(json[identifier]);
        }

        adapt(json) {
            return {
                html:           json.html,
                params:         json.params,
                placeholders:   json.placeholders,
            };
        }

        clean() {
            this.items = {};
            this.Storage.set(this.items);
        }

        error(identifier) {
            console.log('"' + identifier + '" Not found');
        }

        wait(template, callback) {
            if (!this.items[template]) {
                this.getTemplate(template);
            }
            App.wait('App.Template.Storage.data.' + template, function() {
                callback();
            });
            return this;
        }

        /**
         * Requests and parses a html template
         *
         * @param identifier The id to find the template
         * @param parameters Parameters to replace
         * @param output Type of return value (element|jquery|html string)
         *
         * @returns The parsed object.
         */
        parse(identifier, parameters = {}, output = false) {
            let template = this.getTemplate(identifier, false);
            if (template && parameters !== undefined)
                return this.parseTemplate(template, parameters, output);
        }

        /**
         * Get a template as a Promise
         * Do the same as `parse` but returns a promise
         * @todo: Merge this with `parse` when possible
         */
        promise(identifier, parameters = {}, output = false) {
            return this.getTemplate(identifier, true).then(
                template => this.parseTemplate(template, parameters, output)
            );
        }

        /**
         * Parses a html template
         *
         * @param template Template object coming from interface
         * @param parameters Parameters to replace
         * @param output Type of return value (element|jquery|html string)
         *
         * @returns The parsed object.
         */
        parseTemplate(template, parameters, output) {
            let html;
            for (let key in template.params) {
                if (parameters[key] === undefined || parameters[key] === null) parameters[key] = template.params[key];
            }
            /* String needs much less handling for performance */
            if (typeof parameters === 'string') {
                html = this.replace(template.html, 'content', parameters);
            } else {
                html = this.parseString(template.html, parameters, template.placeholders).replace(/}\}/g, '-->').replace(/{\{/g, '<!--');
            }
            switch (output) {
                case 'element':
                    let div = document.createElement('DIV');
                    div.innerHTML = html;
                    return div.firstChild; // returns a DOM node
                case true:
                case 'jquery':
                    return $(html); // returns a jQuery object @deprecated
                default:
                    return html; // return the html string
            }
        }

        parseString(string, parameters = {}, placeholders) {
            return this.format(string, parameters, placeholders);
        }

        /**
         * format
         *
         * A equivalent to simple string format solution. Furthermore named replacements on base of objects are replaced.
         * E.g. the object {a: {b: 'c'}} replaces "#a.b" by "c".
         *
         * @return string
         */
        format(string, parameters, placeholders = []) {
            string = this.prerender(string);
            /* Process named mappings */
            if (typeof parameters === 'object') {
                /* Find all placeholders from template */
                let ph = placeholders.length ? placeholders : string.match(/{{(.*?)}}/g) || [];
                ph.map(val => val.replace(/}\}/g, '').replace(/{\{/g, '')).forEach(placeholder => {
                    let value = parameters[placeholder];
                    if (value === null) value = '';
                    if (placeholder.indexOf('.') > -1 && value === undefined) {
                        value = function() {
                            let data, i = 0, exist = null, split = placeholder.split('.');
                            split.forEach(name => {
                                let source = (exist === null) ? parameters : exist;
                                if (source[name] !== undefined) {
                                    exist   = source[name];
                                    data    = (++i == split.length) ? exist : undefined ;
                                }
                            });
                            return data;
                        }();
                    }
                    if (value !== undefined) string = this.replace(string, placeholder, value);
                });
                return string;
            }

            /* Process numbered mappings. */
            return string.replace(/#(\d+)/g, function(match, number) {
                return (typeof parameters[number] !== 'undefined') ? parameters[number] : match;
            });
        };

        replace(string, placeholder, value) {
            return string.replace(new RegExp('{{' + placeholder + '}}', 'g'), value);
        }

        /**
         * Prerender template and prepare it for layout
         * @param string
         * @returns {*}
         */
        prerender(string) {
            // translate image source attr
            if (string.search('data-template-source="')) {
                string = string.replace(/data-template-source/g, 'src');
            }
            return string;
        }

        /**
         * Parse a component
         * This will start a component instance automatically before rendering (it might take a more render time)
         * This helps to preload resources
         * @param identifier
         * @param parameters
         * @param async
         * @returns string
         */
        component(identifier, parameters = {}, async = true) {
            if (async) {
                return this.promise(identifier, parameters, 'element')
                    .then(template => this.parseComponent(template));
            }
            return this.parseComponent(this.parse(identifier, parameters, 'element'));
        }
        parseComponent(template) {
            const html = template.outerHTML;
            new App.Component(template);
            return html;
        }

        /**
         * Replace or update the html code of a template with actual/given state code
         * @param identifier String Name of template to replace
         * @param html String Html to be replace with (optional)
         * @return {Template}
         */
        replaceHtmlState(identifier, html = null) {
            this.addTemplate(identifier, html || this.getActualHtmlState(identifier));
            return this;
        }

        /**
         * Get the actual state/html from template
         * @param identifier String Name of template to replace
         * @return {string}
         */
        getActualHtmlState(identifier) {
            return document.querySelector('[data-template-state-name=' + identifier + ']').outerHTML;
        }

        /**
         * Save state of all templates that require it
         * @return {Template}
         */
        saveState() {
            document.querySelectorAll('[data-template-state-name]').forEach(item => {
                App.Template.replaceHtmlState(item.dataset.templateStateName);
            });
            return this;
        }

    }
    /* Set Class into APP */
    App.Template = new Template();
})();
